"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InnerBannerFull = void 0;
const image_1 = __importDefault(require("next/image"));
const react_1 = __importDefault(require("react"));
const class_variance_authority_1 = require("class-variance-authority");
const Container_1 = require("../Container");
const Row_1 = require("../Row");
const utils_1 = require("../utils");
// Define variants using CVA
const containerVariants = (0, class_variance_authority_1.cva)('relative ', // Base classes
{
    variants: {
        color: {
            orange: "bg-[#EF9300E5]",
            purple: "bg-[#BB008EE5]",
            green: "bg-brandSecondary",
        },
    },
    defaultVariants: {
        color: 'green', // Default color variant
    },
});
const InnerBannerFull = ({ imageSrc, imageAlt = 'Image', color, className, children, contentClass, imageClass, priority, loading, }) => {
    return (react_1.default.createElement("div", { className: (0, utils_1.cn)(containerVariants({ color }), className) },
        react_1.default.createElement("div", { className: (0, utils_1.cn)("w-full lg:w-[55%] relative lg:absolute right-0 top-0 h-[158px] md:h-[300px] lg:hidden", imageClass) },
            react_1.default.createElement(image_1.default, { src: imageSrc, className: (0, utils_1.cn)("object-cover"), layout: "fill", alt: imageAlt, loading: loading || "eager", ...(priority && { priority: true, fetchPriority: "high" }) })),
        react_1.default.createElement(Container_1.Container, { className: "px-6 2md:px-12 max-w-[1536px] mx-auto order-1 lg:order-0" },
            react_1.default.createElement(Row_1.Row, { className: (0, utils_1.cn)("flex flex-col lg:flex-row lg:min-h-[350px]") },
                react_1.default.createElement("div", { className: (0, utils_1.cn)("flex flex-col lg:flex-row w-full") },
                    react_1.default.createElement("div", { className: (0, utils_1.cn)("w-full lg:w-[43%] gap-6 flex flex-col justify-center p-6 pt-4 lg:py-10", contentClass) }, children)))),
        react_1.default.createElement("div", { className: (0, utils_1.cn)("w-full lg:w-[55%] relative lg:absolute right-0 top-0 h-full hidden lg:block", imageClass) },
            react_1.default.createElement(image_1.default, { src: imageSrc, className: (0, utils_1.cn)("object-cover"), layout: "fill", alt: imageAlt, loading: loading || "eager", ...(priority && { priority: true, fetchPriority: "high" }) }))));
};
exports.InnerBannerFull = InnerBannerFull;
